function IncludedCheck({partialPerk = false}) {
  const color = partialPerk ? '#FFB32E' : '#80C8A0'

  return <svg className='included-check' viewBox='0 0 26 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 17.8821L10.3646 30.3626L23.6692 1' stroke={color} strokeWidth='3.85784' />
  </svg>
}

export default IncludedCheck;